// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-outer-div[data-v-3a6fc09e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 25px;\n  border-radius: 4px;\n  width: 100%;\n}\n.percent-bar-holder[data-v-3a6fc09e] {\n  width: 100%;\n}\n.div-percent-bar[data-v-3a6fc09e] {\n  border-radius: 3px;\n  display: inline-block;\n  height: 100%;\n}\n.div-percent-value[data-v-3a6fc09e] {\n  min-width: 34px;\n  max-width: 34px;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
